// resources/scripts/fontawesome.js

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { byPrefixAndName } from '@awesome.me/kit-f3b9f909f5/icons';

const icons = [
  byPrefixAndName?.fas?.phone,
  byPrefixAndName?.fass?.star,
  byPrefixAndName?.fass?.arrowRight,
  byPrefixAndName?.fass?.chevronRight,
  byPrefixAndName?.fass?.quoteLeft,
  byPrefixAndName?.fass?.quoteRight,
].filter(Boolean);

if (icons.length) {
  library.add(...icons);

  document.addEventListener('DOMContentLoaded', () => {
    dom.i2svg();
  });
}
